/* Moon Island - panier : petites corrections de texte et message de livraison offerte (page /cart et panier latéral) */
(function () {
  var POLICY = (window.miRoot || '') + '/policies/shipping-policy';
  var pending = false;
  var filling = false;

  var I = window.miI18n || {};
  function money(cents, cur) {
    try {
      return new Intl.NumberFormat(window.miLocale || 'fr', { style: 'currency', currency: cur || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  /* Message « Plus que X pour la livraison offerte » (le réglage du thème est vide) */
  function fillGoal() {
    if (filling) return;
    var boxes = document.querySelectorAll('.cart-progress-bar-wrapper:not(.full) .goal-message');
    var empty = Array.prototype.filter.call(boxes, function (b) { return !b.textContent.trim(); });
    if (!empty.length) return;
    filling = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        empty.forEach(function (b) {
          var w = b.closest('.cart-progress-bar-wrapper');
          var threshold = parseInt(w && w.getAttribute('data-threshold'), 10) || 5000;
          var left = threshold - cart.total_price;
          if (left > 0 && !b.textContent.trim()) {
            b.textContent = (I.free_left || '').replace('{amount}', money(left, cart.currency));
          }
        });
      })
      .catch(function () {})
      .then(function () { filling = false; });
  }

  function fix() {
    pending = false;
    var links = document.querySelectorAll('.tax-note a');
    Array.prototype.forEach.call(links, function (a) {
      var h = a.getAttribute('href') || '';
      if (h.indexOf('{{') > -1 || h.indexOf('notranslate') > -1) a.setAttribute('href', POLICY);
    });
    var labels = document.querySelectorAll('.cart-note .form-label');
    Array.prototype.forEach.call(labels, function (l) {
      if (I.order_note && l.textContent.replace(/\s+/g, ' ').trim() !== I.order_note) {
        l.textContent = I.order_note;
      }
    });
    fillGoal();
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(fix);
  }
  fix();
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
})();